<template>
    <listCompaniesComponent />
</template>

<script>
import listCompaniesComponent from "@/views/companies/pages/list_companies/components/list_companies_component.vue/"
export default {
    name: "companies",
    components: {
        listCompaniesComponent
    },
}
</script>

<style lang="css" scoped>
</style>